import { useMediaQuery, useTheme } from '@mui/material'
import { ProductsViewsTable } from './products-views-table'
import { useAccountProductsViews } from 'src/hooks'
import { ProductsViewsGrid } from './product-views-grid'
import { Loader } from '../loader'

const ProductsViews = () => {
  const { data, isLoading } = useAccountProductsViews()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  if (isLoading) {
    return <Loader />
  }

  return isTablet ? (
    <ProductsViewsGrid items={data || []} />
  ) : (
    <ProductsViewsTable rows={data || []} />
  )
}

export { ProductsViews }
